import styled from "styled-components";

export const QuotesRoot = styled.section`
    background: var(--checked-in-background);
    min-height: calc(100dvh - 70px);
    color: #000;
`;

export const QuoteCarousel = styled.div`
    display: flex;
    align-items: center;
    min-height: calc(100dvh - 70px);
    gap: 24px;
    padding: 24px max(24px, calc((100% - 420px) / 2));
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    > article { flex: 0 0 min(82vw, 420px); scroll-snap-align: center; }
`;

export const QuotePanel = styled.article<{ $full: boolean }>`
    position: relative;
    min-width: 0;
    width: ${p => p.$full ? "min(100%, calc((100dvh - 70px) * 9 / 16))" : "auto"};
    height: ${p => p.$full ? "auto" : "min(72dvh, 680px)"};
    aspect-ratio: ${p => p.$full ? "9 / 16" : "auto"};
    min-height: ${p => p.$full ? "0" : "320px"};
    margin: ${p => p.$full ? "0 auto" : "0"};
    border-radius: ${p => p.$full ? "0" : "28px"};
    overflow: hidden;
    background: ${p => p.$full ? "var(--checked-in-background)" : "#fff"};
    box-shadow: ${p => p.$full ? "none" : "0 5px 12px #0003"};
    > button[aria-label="Close quote"] { position: absolute; top: 16px; right: 16px; z-index: 2; }
`;

export const QuoteArtwork = styled.div<{ $interactive: boolean }>`
    display: grid;
    width: 100%;
    height: 100%;
    cursor: ${p => p.$interactive ? "pointer" : "default"};
    > img, > blockquote { grid-area: 1 / 1; min-height: 0; min-width: 0; }
    > img { width: 100%; height: 100%; object-fit: cover; }
    blockquote { display: flex; flex-direction: column; margin: 0; padding: 72px 24px 110px;
        white-space: pre-wrap; overflow-wrap: anywhere; overflow: auto; line-height: 1.25; }
    cite { display: block; margin-top: 16px; font-size: 0.65em; }
`;

export const ArticleAction = styled.div`
    position: absolute;
    bottom: 24px;
    left: 8%;
    width: 84%;
    button { width: 100%; background: #fff; color: #000; border-color: #fff; box-shadow: 0 2px 6px #0002;
        min-height: 66px; justify-content: flex-start; padding: 10px 14px; gap: 10px; text-align: left; }
    button > svg { width: 28px; height: 28px; margin-left: auto; }
    button > img { width: 44px; height: 44px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
    button > span { min-width: 0; flex: 1; display: flex; flex-direction: column; gap: 4px; }
    button > span:first-child { margin-left: 14px; }
    strong { font-size: 15px; }
    button > span > span { font-size: 13px; font-weight: 400; overflow-wrap: anywhere; }
`;

export const QuoteArticleContent = styled.article`
    background: #fff;
    padding: 24px 20px;
    color: #000;
    font-size: 17px;
    line-height: 1.5;
    overflow-wrap: anywhere;
    h1 { font-size: 28px; line-height: 1.2; margin: 0 0 28px; }
    p { margin: 0 0 20px; }
    ul, ol { padding-left: 28px; margin: 16px 0; }
    a { color: inherit; text-decoration: underline; }
    > img { display: block; max-width: 100%; height: auto; margin: 24px auto 0; }
    @media (min-width: 760px) { padding: 32px 48px; }
`;
